import React from "react";
import CustomerPersonaCards from "../customer_personas/CustomerPersonaCards";

const Dashboard = () => {
  return (
    <div>
      <CustomerPersonaCards />
    </div>
  );
};

export default Dashboard;
